const CONTENT = {
  about: {
    title: "About The Fin Desk",
    kicker: "About",
    body: [
      ["p", "The Fin Desk is an independent digital publication covering finance, fintech, payments, banking, cards, financial infrastructure, digital assets and regulation — with a strong European focus and coverage of major global developments."],
      ["p", "We report on the infrastructure behind modern finance: payment orchestration, gateways and processors, card networks, open banking, embedded finance, Banking-as-a-Service, ledger systems, digital wallets and the technology companies building them."],
      ["h2", "Our approach"],
      ["p", "We prioritise primary sources — regulators, central banks, official company announcements and filings — and use credible secondary financial publications for context and confirmation. We clearly distinguish confirmed fact from company claim, industry analysis and editorial interpretation."],
      ["h2", "Independence"],
      ["p", "Editorial decisions are made independently of commercial relationships. Sponsored and partner content is always clearly labelled and never disguised as independent reporting."],
    ],
  },
  "editorial-policy": {
    title: "Editorial Policy", kicker: "Standards",
    body: [
      ["p", "The Fin Desk is committed to accurate, original and independent reporting on financial technology and infrastructure."],
      ["h2", "Sourcing"],
      ["p", "We prefer primary sources wherever possible: regulators, central banks, government agencies, official company announcements, investor relations, exchange filings and official press releases. Secondary financial publications are used for context and confirmation."],
      ["h2", "Originality"],
      ["p", "We never copy another publication's article or reproduce substantial portions of source material. Our articles are original reporting summaries, explainers or analysis based on researched facts, using multiple sources where practical."],
      ["h2", "Accuracy"],
      ["p", "We never invent company announcements, regulatory decisions, partnerships, funding rounds, acquisition values, statistics, quotations, executives, job titles or dates. Material facts that cannot be verified are flagged rather than asserted."],
      ["h2", "Editorial automation"],
      ["p", "The Fin Desk uses an assistive editorial research agent to discover developments, research primary sources and prepare drafts. No article is published without human review and approval."],
    ],
  },
  "corrections-policy": {
    title: "Corrections Policy", kicker: "Standards",
    body: [
      ["p", "We correct errors promptly and transparently."],
      ["h2", "How we handle corrections"],
      ["p", "When a factual error is identified, we update the article and note the correction where the change is material. Significant corrections are clearly indicated with an updated date."],
      ["h2", "Reporting an error"],
      ["p", "If you believe an article contains an inaccuracy, please contact us via the Contact page with details and, where possible, a source. We review every request."],
    ],
  },
  "privacy-policy": {
    title: "Privacy Policy", kicker: "Legal",
    body: [
      ["p", "This policy explains how The Fin Desk handles personal data."],
      ["h2", "Information we collect"],
      ["p", "We collect the email address you provide when subscribing to The Fin Desk Daily, and any details submitted through our contact or advertising forms. We store this information securely and use it only for the stated purpose."],
      ["h2", "Newsletter"],
      ["p", "You can unsubscribe from The Fin Desk Daily at any time. We do not sell subscriber data."],
      ["h2", "Contact"],
      ["p", "For any privacy enquiry, please use the Contact page."],
    ],
  },
  terms: {
    title: "Terms of Use", kicker: "Legal",
    body: [
      ["p", "By accessing The Fin Desk you agree to these terms."],
      ["h2", "Content"],
      ["p", "The Fin Desk provides journalism and analysis for information purposes. Nothing on this site constitutes financial, investment or legal advice."],
      ["h2", "Intellectual property"],
      ["p", "Articles and design are the property of The Fin Desk. You may share links freely; you may not reproduce substantial portions without permission."],
      ["h2", "Sponsored content"],
      ["p", "Commercial content is clearly labelled as Sponsored or Partner Content and is subject to the same accuracy standards."],
    ],
  },
};

export default function StaticPage({ slug }) {
  const c = CONTENT[slug];
  if (!c) return <div className="max-w-3xl mx-auto px-6 py-24 text-center"><h1 className="font-serif text-4xl">Page not found</h1></div>;
  return (
    <div className="max-w-[760px] mx-auto px-4 sm:px-6 py-12">
      <div className="border-b-2 border-ink pb-3 mb-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">{c.kicker}</div>
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink mt-1">{c.title}</h1>
      </div>
      <div className="prose-editorial">
        {c.body.map(([tag, text], i) => tag === "h2" ? <h2 key={i}>{text}</h2> : <p key={i}>{text}</p>)}
      </div>
    </div>
  );
}
